import { Tooltip } from "react-tooltip";
import { useDispatch, useSelector } from "react-redux";
import { useCallback, useEffect, useState } from "react";
import { fromJS } from "immutable";
import { getItem } from "../api/ProjectApi";
import { getIssue } from "../api/JiraApi";
import { getJirItemUrl } from "../api/api";
import { useNavigate } from "react-router-dom";
import LayoutAction from "../actions/LayoutAction";
import { SmallLoading } from "../main/Loading";
import { navigateTo } from "../Navigator";
import NameHoverCard from "../board/components/NameHoverCard";

const SUPPORTED_TYPES = ["COMPANY", "CONTACT", "SALE"];

const InformationInlineDialog = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const currentItem = useSelector((state: any) => {
    const value = state.layoutReducer.get("hoveringDataItem") || fromJS({});
    return value;
  });
  const isOpen = useSelector((state: any) => {
    const value = state.layoutReducer.getIn(["hoveringDataItem", "isOpen"]) || false;
    return value;
  });

  const datasource =
    useSelector((state: any) => state.taskReducer.getIn(["GRID", "children"])) || fromJS([]);

  const [item, setItem] = useState(fromJS({ loading: true }));

  const loadItem = () => {
    const itemId = currentItem.get("value");
    if (currentItem.get("type") == "TASK") {
      setItem(fromJS({ loading: true }));
      getIssue(itemId).then((data) => {
        setItem(
          fromJS({
            ...data,
            loading: false,
          })
        );
      });
    } else {
      const localItem = datasource.find((item) => item.get("id") == itemId);
      if (localItem) {
        // Local data available — set directly without loading state to avoid flicker
        setItem(
          fromJS({
            ...localItem.toJS(),
            loading: false,
          })
        );
      } else {
        setItem(fromJS({ loading: true }));
        getItem(itemId).then((data) => {
          setItem(
            fromJS({
              ...data,
              loading: false,
            })
          );
        });
      }
    }
  };

  useEffect(() => {
    if (currentItem && currentItem.get && currentItem.get("value")) {
      // Clear old item immediately to prevent stale data flash
      setItem(fromJS({}));
      loadItem();
    } else {
      setItem(fromJS({}));
    }
  }, [currentItem]); // eslint-disable-line react-hooks/exhaustive-deps

  // Close tooltip for unsupported types (e.g. TASK/Jira issues)
  useEffect(() => {
    if (isOpen && item.get("id") && !SUPPORTED_TYPES.includes(item.get("type"))) {
      dispatch(LayoutAction.hoverDataItem({ isOpen: false }));
    }
  }, [item, isOpen]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleClickName = useCallback(
    (tab?: string) => {
      const tabParam = tab ? `&tab=${tab}` : "";
      const jiraUrl = getJirItemUrl({
        workspaceId: item.get("projectId"),
        itemId: item.get("id"),
        type: item.get("type"),
        view: "BOARD",
      });
      const appUrl = `/workspaces/${item.get("projectId")}/items/${item.get(
        "id"
      )}?type=${item.get("type")}&view=BOARD${tabParam}`;
      navigateTo({
        jiraUrlParams: { relativeUrl: jiraUrl },
        appUrl,
        navigate,
      });
    },
    [item, navigate]
  );

  const renderInfo = () => {
    if (item.get("id") && isOpen) {
      if (item.get("loading")) {
        return (
          <div className={"shadow-xl rounded-sm p-2 bg-white w-48 h-40"}>
            <SmallLoading />
          </div>
        );
      }
      const itemType = item.get("type");
      if (SUPPORTED_TYPES.includes(itemType)) {
        return <NameHoverCard task={item} taskType={itemType} onClickName={handleClickName} />;
      }
      return null;
    }
    return null;
  };

  return (
    <Tooltip
      offset={4}
      clickable
      opacity={100}
      className={"crm-tooltip"}
      id={"information-tooltip"}
      place={"bottom-start"}
      style={{
        zIndex: 10000,
        backgroundColor: "transparent",
      }}
      noArrow={true}
      float={false}
      positionStrategy={"fixed"}
    >
      {renderInfo()}
    </Tooltip>
  );
};
export default InformationInlineDialog;
